export const MINUTE_STEP_PL = 30;
